"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionBank = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const newIdFormQuestions_1 = __importDefault(require("@opsbase/lib-form/newId/newIdFormQuestions"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useQuestionSets_1 = __importDefault(require("@opsbase/react-gql-hooks/questionset/useQuestionSets"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const SearchBox_1 = __importDefault(require("@opsbase/web-textfield/SearchBox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text/Text"));
const react_1 = __importStar(require("react"));
const react_sortablejs_1 = require("react-sortablejs");
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const QuestionBankItem_1 = __importDefault(require("./QuestionBankItem"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
function QuestionBank(props) {
    var _a;
    const { counts = {}, highlightIfZero = false } = props;
    const self = (0, useSelf_1.default)();
    const { formConstraints } = (0, useFedSetup_1.default)();
    const { doAddSubQuestions, canDrop } = (0, useFedActions_1.default)();
    const [keyword, setKeyword] = (0, react_1.useState)();
    const [dragging, setDragging] = (0, react_1.useState)();
    const allowedIds = (_a = formConstraints === null || formConstraints === void 0 ? void 0 : formConstraints[FormQuestionType_1.default.QUESTIONSET]) === null || _a === void 0 ? void 0 : _a.ids;
    const { language, isAlt } = (0, useSysLang_1.default)();
    const questionSets = (0, useQuestionSets_1.default)({
        variables: { keyword },
    });
    const availableQuestionSets = (0, react_1.useMemo)(() => {
        var _a, _b;
        return ((_b = (_a = questionSets === null || questionSets === void 0 ? void 0 : questionSets.data) === null || _a === void 0 ? void 0 : _a.filter(s => { var _a; return !!((_a = s.form) === null || _a === void 0 ? void 0 : _a.length); })) === null || _b === void 0 ? void 0 : _b.filter(s => !allowedIds || allowedIds.indexOf(s.id) >= 0)) || [];
    }, [questionSets, allowedIds]);
    const handleDragStart = (0, useCallforward_1.default)(type => e => { var _a; return setDragging((_a = availableQuestionSets === null || availableQuestionSets === void 0 ? void 0 : availableQuestionSets.filter(s => s.type === type)) === null || _a === void 0 ? void 0 : _a[e.oldIndex]); }, [availableQuestionSets]);
    const handleDragMove = (0, react_1.useCallback)(e => {
        var _a, _b, _c;
        if ((_b = (_a = e === null || e === void 0 ? void 0 : e.to) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.startsWith('qsetId_'))
            return false;
        if (((_c = e === null || e === void 0 ? void 0 : e.related) === null || _c === void 0 ? void 0 : _c.className.indexOf('noDnD')) >= 0 && (e === null || e === void 0 ? void 0 : e.willInsertAfter))
            return false;
        return canDrop(e.to.id, e.newIndex, FormQuestionType_1.default.QUESTIONSET);
    }, [canDrop]);
    const handleDragEnd = (0, react_1.useCallback)(e => {
        var _a, _b;
        // Following line is a bit of a hack, but... it basically means
        // if the user presses ESC mid DnD the action is cancelled
        if (!((_a = e === null || e === void 0 ? void 0 : e.originalEvent) === null || _a === void 0 ? void 0 : _a.cancelable))
            return false;
        if (!dragging)
            return false;
        const destLid = (_b = e === null || e === void 0 ? void 0 : e.to) === null || _b === void 0 ? void 0 : _b.id;
        const destIdx = e === null || e === void 0 ? void 0 : e.newIndex;
        doAddSubQuestions(destLid, destIdx, (0, newIdFormQuestions_1.default)([Object.assign(Object.assign({}, dragging.form[0]), { parentQSetId: dragging.id })]), true);
    }, [doAddSubQuestions, dragging]);
    const handleSetQuestionSets = (0, react_1.useCallback)(doNothing_1.default, []);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true, scrollY: true },
        react_1.default.createElement(SearchBox_1.default, { keyword: keyword, onChange: setKeyword, placeholder: 'Search for question by title' }),
        self.settings.opTypes
            .map(opType => ({
            opType,
            qSets: availableQuestionSets === null || availableQuestionSets === void 0 ? void 0 : availableQuestionSets.filter(s => s.type === opType.key),
        }))
            .filter(({ qSets }) => !!(qSets === null || qSets === void 0 ? void 0 : qSets.length))
            .map(({ opType, qSets }) => (react_1.default.createElement(Vertical_1.default, { shrink: true, key: opType.key },
            react_1.default.createElement(Text_1.default, { variant: "h1" }, opType.title),
            react_1.default.createElement(react_sortablejs_1.ReactSortable, { id: 'qsetId_' + opType.key, group: "formtree", handle: ".dragHandle", animation: 100, dragClass: 'pickerDrag', easing: "cubic-bezier(1, 0, 0, 1)", list: qSets, setList: handleSetQuestionSets, onStart: handleDragStart(opType.key), onMove: handleDragMove, onEnd: handleDragEnd }, qSets.map((s, idx) => {
                var _a, _b;
                const count = (counts === null || counts === void 0 ? void 0 : counts[s.id]) || 0;
                let localTitle = s.title;
                if (isAlt) {
                    localTitle = (_b = (_a = s.titleAlt) === null || _a === void 0 ? void 0 : _a[language]) !== null && _b !== void 0 ? _b : s.title;
                }
                return (react_1.default.createElement(QuestionBankItem_1.default, { key: s.id + '_' + idx, highlight: highlightIfZero && count === 0, title: localTitle, keywordHighlight: keyword, count: count }));
            })))))));
}
exports.QuestionBank = QuestionBank;
exports.default = QuestionBank;
